import { render } from "./RichTypeList.vue?vue&type=template&id=01220114&scoped=true"
import script from "./RichTypeList.vue?vue&type=script&lang=js"
export * from "./RichTypeList.vue?vue&type=script&lang=js"

import "./RichTypeList.vue?vue&type=style&index=0&id=01220114&lang=sass&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01220114"]])

export default __exports__